export default __webpack_public_path__ + "static/media/thinking.94cd0057.svg";